export default __webpack_public_path__ + "static/media/chevron-forward.2342aa43.svg";